import { UI } from '../nextpage';

export class Slider {
    constructor(private NP: UI) {
        // Sliders
        this.NP.registerResizeFunction("slider", () => {
            const sliders = document.querySelectorAll(".slider:not(.cards)");
            sliders.forEach((slider: HTMLDivElement) => {
                const slideWrapper = slider.querySelector(".slide-wrapper") as HTMLDivElement;
                const slideControls = slider.querySelector(".controls") as HTMLDivElement;
                const labelContainer = slider.querySelector(".labels") as HTMLUListElement;
                const isGallery = slider.classList.contains("gallery");
                let wrapperHeight = 0;

                [].forEach.call(slideWrapper.children, (slide: HTMLDivElement) => {
                    if (!slide.classList.contains("slide")) {
                        return;
                    }
                    const slideHeight = slide.clientHeight;
                    if (slideHeight <= wrapperHeight) {
                        return;
                    }
                    wrapperHeight = slideHeight;
                });
                slideWrapper.style.height = wrapperHeight + "px";
                if (slideControls !== null) {
                    slideControls.style.height = wrapperHeight + "px";
                }

                let currentSet = this.NP.numberFromData(slider.dataset.currentSet);
                if (currentSet === -1) {
                    currentSet = 0;
                }
                let maxLabels = this.NP.numberFromData(slider.dataset.maxLabels);
                if (maxLabels === -1) {
                    maxLabels = 3;
                }
                if (labelContainer === null || isGallery) {
                    return;
                }
                const labels = [].filter.call(labelContainer.children, (label: HTMLLIElement) => {
                    return label.nodeName === "LI" && !label.classList.contains("icon-menu-left") && !label.classList.contains("icon-menu-left");
                });
                const maxSet = Math.ceil(labels.length / maxLabels) - 1;
                let currentLabel = -1;
                labels.forEach((label: HTMLLIElement, i: number) => {
                    if (label.classList.contains("aria-selected")) {
                        currentLabel = i;
                    }
                });
                const lastLabelIndex = labels.length - 1;
                const menuLeft = labelContainer.querySelector(".icon-menu-left");
                const menuRight = labelContainer.querySelector(".icon-menu-right");
                this.NP.toggleAriaState(menuLeft, "disabled", this.NP.properties.isMobile ? (currentLabel === 0) : (currentSet === 0));
                this.NP.toggleAriaState(menuRight, "disabled", this.NP.properties.isMobile ? (currentLabel === lastLabelIndex) : (currentSet === maxSet));

                if (isGallery) {
                    return;
                }

                let maxCaptionHeight = 0;
                const captionWrapper = slider.querySelector(".caption-wrapper") as HTMLDivElement;
                if (captionWrapper === null) {
                    return;
                }
                [].forEach.call(captionWrapper.children, (caption: HTMLElement) => {
                    if (!caption.classList.contains("caption")) {
                        return;
                    }
                    const captionHeight = caption.clientHeight;
                    if (captionHeight <= maxCaptionHeight) {
                        return;
                    }
                    maxCaptionHeight = captionHeight;
                });

                captionWrapper.style.height = maxCaptionHeight + "px";
            });
        });
        this.NP.registerEvent("sliderPagerClick", (e: Event) => {
            e.preventDefault();
            if (e.target === undefined || e.target === null) {
                return;
            }
            const clickedPager = e.target as HTMLElement;
            const slider = clickedPager.parentElement.parentElement as HTMLDivElement;
            const slideWrapper = slider.querySelector(".slide-wrapper") as HTMLDivElement;
            const slides = [].filter.call(slideWrapper.children, (slide: HTMLDivElement) => {
                return slide.classList.contains("slide");
            });
            const isGallery = slider.classList.contains("gallery") || slider.classList.contains("utility-flex");
            const slideLabels = [].filter.call(clickedPager.parentElement.children, (sibling: HTMLElement) => {
                return !sibling.classList.contains("icon-menu-left") && !sibling.classList.contains("icon-menu-right");
            });
            const prev = clickedPager.classList.contains("icon-menu-left");

            let currentSlide = -1;
            slides.forEach((s: HTMLDivElement, i: number) => {
                if (!s.classList.contains("aria-selected")) {
                    return;
                }
                currentSlide = i;
            });
            const maxLabels = this.NP.numberFromData(slider.dataset.maxLabels);
            const currentSet = this.NP.numberFromData(slider.dataset.currentSet);
            const lastSlideIndex = slides.length - 1;
            let targetSlide = prev ? currentSlide - 1 : currentSlide + 1;
            targetSlide = targetSlide === -1 ? lastSlideIndex : targetSlide > lastSlideIndex ? 0 : targetSlide;

            if (isGallery) {
                const dotContainer = slider.querySelector(".dots");
                const dots = dotContainer.querySelectorAll("button");
                const captionsContainer = slider.querySelector(".caption-wrapper");
                const captions = captionsContainer.querySelectorAll(".caption");
                dots.forEach((dot, i) => {
                    this.NP.toggleAriaState(dot, "pressed", i === targetSlide);
                });
                captions.forEach((caption, i) => {
                    this.NP.toggleAriaState(caption, "selected", i === targetSlide);
                });
                slides.forEach((slide: HTMLDivElement, i: number) => {
                    this.NP.toggleAriaState(slide, "selected", i === targetSlide);
                });
                slider.dataset.currentSet = targetSlide.toString();
                return;
            }

            if (this.NP.properties.isMobile || slider.classList.contains("single-slide")) {
                slideLabels.forEach((label: HTMLUListElement, i: number) => {
                    this.NP.toggleAriaState(label, "selected", i === targetSlide);
                });
                slides.forEach((slide: HTMLDivElement, i: number) => {
                    this.NP.toggleAriaState(slide, "selected", i === targetSlide);
                });
                if (prev) {
                    this.NP.toggleAriaState(clickedPager, "disabled", targetSlide === 0);
                    this.NP.toggleAriaState(clickedPager.parentElement.querySelector(".icon-menu-right"), "disabled", targetSlide === lastSlideIndex);
                } else {
                    this.NP.toggleAriaState(clickedPager, "disabled", targetSlide === lastSlideIndex);
                    this.NP.toggleAriaState(clickedPager.parentElement.querySelector(".icon-menu-left"), "disabled", targetSlide === 0);
                }
                const slideTargetSet = Math.floor(targetSlide / maxLabels);
                if (slideTargetSet === currentSet) {
                    return;
                }
                slider.dataset.currentSet = slideTargetSet.toString();
                const xTranslate = slideTargetSet * maxLabels * -100;
                slideLabels.forEach((label: HTMLUListElement) => {
                    label.style.transform = "translateX(" + xTranslate + "%)";
                });
                return;
            }
            const maxSet = Math.ceil(slideLabels.length / maxLabels) - 1;
            const targetSet = prev ? (currentSet === 0 ? 0 : currentSet - 1) : (currentSet >= maxSet ? maxSet : currentSet + 1);
            if (targetSet === -1 || targetSet === currentSet) {
                return;
            }
            if (prev) {
                this.NP.toggleAriaState(clickedPager, "disabled", targetSet === 0);
                this.NP.toggleAriaState(clickedPager.parentElement.querySelector(".icon-menu-right"), "disabled", targetSet === maxSet);
            } else {
                this.NP.toggleAriaState(clickedPager, "disabled", targetSet === maxSet);
                this.NP.toggleAriaState(clickedPager.parentElement.querySelector(".icon-menu-left"), "disabled", targetSet === 0);
            }
            slider.dataset.currentSet = targetSet.toString();
            const xTranslate = targetSet * maxLabels * -100;
            slideLabels.forEach((label: HTMLUListElement) => {
                label.style.transform = "translateX(" + xTranslate + "%)";
            });
        });
        this.NP.registerEvent("galleryDotClick", (e: Event) => {
            if (this.NP.properties.isMobile) {
                return;
            }
            const clicked = e.target as HTMLButtonElement;
            const slider = clicked.parentElement.parentElement as HTMLDivElement;
            const slideWrapper = slider.querySelector(".slide-wrapper");
            const slides = [].filter.call(slideWrapper.children, (slide: HTMLDivElement) => {
                return slide.classList.contains("slide");
            });
            const captionWrapper = slider.querySelector(".caption-wrapper");
            const captions = [].filter.call(captionWrapper.children, (caption: HTMLElement) => {
                return caption.classList.contains("caption");
            });
            let slideIndex = -1;
            [].forEach.call(clicked.parentElement.children, (c: HTMLElement, i: number) => {
                if (c !== clicked) {
                    this.NP.toggleAriaState(c, "pressed", false);
                    return;
                }
                this.NP.toggleAriaState(c, "pressed", true);
                slideIndex = i;
            });
            slides.forEach((slide: HTMLDivElement, i: number) => {
                this.NP.toggleAriaState(slide, "selected", i === slideIndex);
            });
            captions.forEach((caption: HTMLDivElement, i: number) => {
                this.NP.toggleAriaState(caption, "selected", i === slideIndex);
            });
            slider.dataset.currentSet = slideIndex.toString();
        });
        this.NP.registerEvent("sliderLabelClick", (e: Event) => {
            if (this.NP.properties.isMobile) {
                return;
            }
            const clicked = e.target as HTMLElement;
            const slider = clicked.parentElement.parentElement as HTMLDivElement;
            const slideWrapper = slider.querySelector(".slide-wrapper");
            const slides = [].filter.call(slideWrapper.children, (slide: HTMLDivElement) => {
                return slide.classList.contains("slide");
            });
            const slideLabels = [].filter.call(clicked.parentElement.children, (sibling: HTMLElement) => {
                return !sibling.classList.contains("icon-menu-left") && !sibling.classList.contains("icon-menu-right");
            });
            const currentSet = this.NP.numberFromData(slider.dataset.currentSet);
            let maxLabels = this.NP.numberFromData(slider.dataset.maxLabels);
            if (maxLabels === -1) {
                maxLabels = 3;
            }
            let slideIndex = -1;
            [].forEach.call(clicked.parentElement.children, (c: HTMLElement, i: number) => {
                if (c !== clicked) {
                    this.NP.toggleAriaState(c, "selected", false);
                    return;
                }
                this.NP.toggleAriaState(c, "selected", true);
                slideIndex = i;
            });
            slides.forEach((slide: HTMLDivElement, i: number) => {
                this.NP.toggleAriaState(slide, "selected", i === slideIndex);
            });
            const targetSet = Math.floor(slideIndex / maxLabels)
            if (currentSet === targetSet) {
                return;
            }
            slider.dataset.currentSet = targetSet.toString();
            const xTranslate = targetSet * maxLabels * -100;
            slideLabels.forEach((label: HTMLElement) => {
                label.style.transform = "translateX(" + xTranslate + "%)";
            });
        });

        this.NP.components.slider = (selector: string | Element | NodeListOf<Element> | Array<Element>): void => {
            this.NP.getComponentSelector(selector).forEach((slider: HTMLDivElement) => {
                const isGallery = slider.classList.contains("gallery") || slider.classList.contains("utility-flex");
                let slides: NodeListOf<HTMLDivElement>;
                let slideWrapper = slider.querySelector(".slide-wrapper") as HTMLDivElement;
                if (slideWrapper === null) {
                    slideWrapper = document.createElement("div");
                    slideWrapper.classList.add("slide-wrapper");
                    slides = slider.querySelectorAll(".slide");
                } else {
                    slides = slideWrapper.querySelectorAll(".slide");
                }
                let maxSlideHeight = 0;
                let maxCaptionHeight = 0;
                let dotCount = 1;
                const dotContainer = document.createElement("div");
                dotContainer.classList.add("dots");
                const captionWrapper = document.createElement("div");
                captionWrapper.classList.add("caption-wrapper");
                let currentSlideIndex = -1;
                slider.dataset.currentSet = '0';
                
                slides.forEach((slide: HTMLDivElement, i: number) => {
                    const slideSelected = slide.classList.contains("aria-selected");
                    if (slideSelected) {
                        currentSlideIndex = i;
                    }
                    this.NP.toggleAriaState(slide, "selected", false);
                    const newDot: HTMLButtonElement = document.createElement("button");
                    newDot.type = "button";
                    newDot.setAttribute("role", "button");
                    newDot.setAttribute("tabIndex", "0");
                    this.NP.toggleAriaState(newDot, "pressed", slideSelected);
                    newDot.textContent = "slide " + dotCount;
                    newDot.addEventListener("click", (e: Event) => this.NP.events.galleryDotClick(e));
                    dotContainer.appendChild(newDot);
                    dotCount = dotCount + 1;
    
                    if (isGallery) {
                        const slideCaption = [].filter.call(slide.children, (c: HTMLElement) => { return c.classList.contains("caption"); })[0];
                        if (slideCaption != null) {
                            const slideCaptionHeight = slideCaption.clientHeight;
                            if (slideCaptionHeight > maxCaptionHeight) {
                                maxCaptionHeight = slideCaptionHeight;
                            }
                            captionWrapper.appendChild(slideCaption);
                        }
                    }
                    const slideHeight = slide.clientHeight;
                    if (slideHeight <= maxCaptionHeight) {
                        return;
                    }
                    if (maxSlideHeight < slideHeight) {
                        maxSlideHeight = slideHeight;
                    }
                });
    
                if (!isGallery) {
                    const labelList = slider.querySelector(".labels");
                    const labels = [].filter.call(labelList.children, (l: HTMLLIElement) => { return l.nodeName === "LI"; });
                    let maxLabels = this.NP.numberFromData(slider.dataset.maxLabels);
                    if (maxLabels === -1) {
                        maxLabels = 3;
                        slider.dataset.maxLabels = maxLabels.toString();
                    }
                    let currentLabelIndex = -1;
                    labels.forEach((label: HTMLElement, i: number) => {
                        label.addEventListener("click", (ev: Event) => this.NP.events.sliderLabelClick(ev));
                        label.style.width = (100 / maxLabels) + "%";
                        if (label.classList.contains("aria-selected")) {
                            currentLabelIndex = i;
                        }
                    });
                    if (currentLabelIndex === -1) {
                        if (currentSlideIndex === -1) {
                            this.NP.toggleAriaState(labels[0], "selected", true);
                            this.NP.toggleAriaState(slides[0], "selected", true);
                        } else {
                            this.NP.toggleAriaState(slides[currentSlideIndex], "selected", true);
                        }
                    } else {
                        this.NP.toggleAriaState(slides[currentLabelIndex], "selected", true);
                    }
                    const labelLeft = document.createElement("li");
                    labelLeft.classList.add("icon-menu-left");
                    this.NP.toggleAriaState(labelLeft, "disabled", true);
                    labelLeft.addEventListener("click", (ev: Event) => this.NP.events.sliderPagerClick(ev));
    
                    const labelRight = document.createElement("li");
                    labelRight.classList.add("icon-menu-right");
                    labelRight.addEventListener("click", (ev: Event) => this.NP.events.sliderPagerClick(ev));
    
                    labelList.appendChild(labelLeft);
                    labelList.appendChild(labelRight);
                    
                    slideWrapper.style.height = maxSlideHeight + "px";
                    slides.forEach((slide: HTMLDivElement) => { slideWrapper.appendChild(slide); });
                    slider.appendChild(slideWrapper);
                } else {
                    const thisSlideIndex = currentSlideIndex === -1 ? 0 : currentSlideIndex;
                    [].forEach.call(captionWrapper.children, (caption: HTMLParagraphElement, i: number) => {
                        this.NP.toggleAriaState(caption, "selected", i === thisSlideIndex);
                    });
                    [].forEach.call(dotContainer.children, (dot: HTMLButtonElement, i: number) => {
                        this.NP.toggleAriaState(dot, "pressed", i === thisSlideIndex);
                    });
                    this.NP.toggleAriaState(slides[thisSlideIndex], "selected", true);
    
                    const controls = document.createElement("div");
                    controls.classList.add("controls");
                    const newLeft = document.createElement("span");
                    newLeft.classList.add("icon-menu-left");
                    newLeft.addEventListener("click", (ev: Event) => this.NP.events.sliderPagerClick(ev));
                    const newRight = document.createElement("span");
                    newRight.classList.add("icon-menu-right");
                    newRight.addEventListener("click", (ev: Event) => this.NP.events.sliderPagerClick(ev));
                    controls.appendChild(newLeft);
                    controls.appendChild(newRight);
                    controls.style.height = maxSlideHeight + "px";
    
                    slides.forEach((slide: HTMLDivElement) => { slideWrapper.appendChild(slide); });
                    slideWrapper.style.height = maxSlideHeight + "px";
                    captionWrapper.style.height = maxCaptionHeight + "px";
    
                    slider.appendChild(controls);
                    slider.appendChild(slideWrapper);
                    slider.appendChild(dotContainer);
                    slider.appendChild(captionWrapper);
                }
    
                slider.classList.toggle("allow-animation", true);
            });
        }
    }
}